import { useEffect, useRef, useState } from "react";

function useTableScroll() {
  const [scrolledClass, setScrolledClass] = useState(false);
  const scrollableTableRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = (scrollableTableRef.current || document.querySelector(".scrollable-table")) as HTMLElement | null;
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    if (el) {
      const onMouseDown = (e: MouseEvent) => {
        isDragging = true;
        el.classList.add("active");
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      };

      const onMouseMove = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const walk = (x - startX) * 2;
        el.scrollLeft = scrollLeft - walk;
      };

      const onMouseUpOrLeave = () => {
        isDragging = false;
        el.classList.remove("active");
      };

      el.addEventListener("mousedown", onMouseDown);
      el.addEventListener("mousemove", onMouseMove);
      el.addEventListener("mouseup", onMouseUpOrLeave);
      el.addEventListener("mouseleave", onMouseUpOrLeave);

      return () => {
        el.removeEventListener("mousedown", onMouseDown);
        el.removeEventListener("mousemove", onMouseMove);
        el.removeEventListener("mouseup", onMouseUpOrLeave);
        el.removeEventListener("mouseleave", onMouseUpOrLeave);
      };
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const threshold = 270;
      const hasScrolled = scrollPosition > threshold;
      setScrolledClass(hasScrolled);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { scrolledClass, scrollableTableRef };
}

export default useTableScroll;
